import { render } from "./PostRaffle.vue?vue&type=template&id=36b6be47&scoped=true"
import script from "./PostRaffle.vue?vue&type=script&lang=js"
export * from "./PostRaffle.vue?vue&type=script&lang=js"

import "./PostRaffle.vue?vue&type=style&index=0&id=36b6be47&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fpv-raffle/fpv-raffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b6be47"]])

export default __exports__